import { put, select, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../../constants/action-types';
import {
  findSegment,
  getOptionIdFromOption,
  getTravellerCount,
} from '../itinerary/selectors';
import {
  getSegmentOption,
  getSelectedRate,
} from '../segment-options/selectors';
import { SelectOptionWithRateAction } from '../selected-options/types';
import { getSelected } from '../selected-rate/selectors';
import { ClearRateAction } from '../selected-rate/types';
import {
  OptionDetailsTypes,
  OptionTypes,
  SegmentResponse,
} from './../../../models/itinerary';
import { SegmentDetailsUpdateAction } from './types';

export function* watcherSaga() {
  yield takeLatest(ActionTypes.OPTION_SELECT_WITH_RATE, worker);
}

function* worker(action: SelectOptionWithRateAction): Generator<any, any, any> {
  const { segmentId, option } = action;
  const optionId = getOptionIdFromOption(option);
  const segment: SegmentResponse = yield select(findSegment(segmentId));
  const itineraryOption: OptionDetailsTypes = yield select(
    getSegmentOption(segmentId, optionId.toString()),
  );
  const selectedRate: OptionTypes | undefined = yield select(getSelected);
  const rate = yield select(getSelectedRate(segmentId, selectedRate || option));
  const travellerCount = yield select(getTravellerCount);

  const updateAction: SegmentDetailsUpdateAction = {
    type: ActionTypes.SEGMENT_DETAILS_UPDATE,
    segment,
    option: itineraryOption,
    rate,
    travellerCount,
  };

  yield put(updateAction);

  if (selectedRate) {
    // Now that the rate has been used, clear it
    const clearRateAction: ClearRateAction = {
      type: ActionTypes.RATE_CLEAR,
    };
    yield put(clearRateAction);
  }
}
